import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./CountCard.css";

type CountCardProps = {
  fetch: () => Promise<number | undefined>;
  title: string;
  to?: string;
};

const CountCard: React.FC<CountCardProps> = ({ fetch, title, to }) => {
  const [count, setCount] = useState<null | number | undefined>(null);
  const navigate = useNavigate();

  const getCount = async () => {
    const results = await fetch();
    setCount(results);
  };

  useEffect(() => {
    getCount();
  }, []);

  return (
    <div
      className={`count-card${to ? " count-card--clickable" : ""}`}
      onClick={() => to && navigate(to)}
    >
      <h3 className="count-card__title">{title}</h3>
      <div className="count-card__content">{count}</div>
    </div>
  );
};

export default CountCard;
